/** Equipe: membros e o status unificado exibido na tela. */
import { z } from "zod";
import { membershipRole } from "../enums.js";
import { uuid } from "./common.js";

/* ---------- Equipe ---------- */
/**
 * Status unificado de membro exibido na Equipe (D-15): compõe convite
 * (`inviteStatus`/`userStatus=invited`) e vínculo (`membershipStatus`).
 */
export const memberStatus = z.enum(["invited", "active", "disabled", "suspended"]);
export type MemberStatus = z.infer<typeof memberStatus>;

export const member = z.object({
  id: uuid,
  name: z.string(),
  email: z.string(),
  role: membershipRole,
  status: memberStatus,
  avatarUrl: z.string().nullable().optional(),
  channels: z.number().int().nonnegative().optional(),
  lastSeenAt: z.string().nullable().optional(),
});
export type Member = z.infer<typeof member>;

/** Troca de papel de um membro pelo owner/admin (PATCH /api/members/:id). */
export const updateMemberRoleInput = z.object({ role: membershipRole });
export type UpdateMemberRoleInput = z.infer<typeof updateMemberRoleInput>;
